exports = module.exports = require("../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container-contact{\n    background-color: white;\n    padding: 23px;\n}\n.general-container-contact{\n  \n}\n.btn-send-contact{\n    border: none;\n    margin: auto;\n    display: flex;\n    margin-top: 20px;\n}", ""]);

